module.exports = __webpack_public_path__ + "media/Video 102.5bde70c7.mp4";